module.exports = __webpack_public_path__ + "static/media/not-equal.89ea17d5.svg";